import PicklistField from 'core/components/validatedForm/DropdownField'
import React from 'react'

const defaultLabel = 'Operating System'

const AwsAmiField = ({
  dropdownComponent,
  region,
  onChange = undefined,
  label = defaultLabel,
  id = 'awsAmiId',
  ...rest
}) => (
  <PicklistField
    DropdownComponent={dropdownComponent}
    disabled={!region}
    id={id}
    label={label}
    region={region}
    onChange={onChange}
    required
    {...rest}
  />
)

export default AwsAmiField
